import merge from 'lodash/merge';
import { setCookie } from '@/utils/cookies';
import policies from '@/config/policies-default.json';
import policiesByRole from '@/config/policies-by-role.json';

/* eslint-disable no-unused-vars, no-shadow */

const initialState = {
  auth: {
    tokenId: false,
  },
  userRole: '',
  fiduciaries: [],
  fiduciary: {
    id: 0,
    code: '',
    name: '',
  },
  policies: {},
};

const actions = {
  setAuthToken: {
    root: true,
    handler({ commit }, tokenId = false) {
      commit('setAuthToken', tokenId);
    },
  },
  setAuthTokenId: {
    root: true,
    handler({ commit }) {
      commit('setAuthTokenId');
    },
  },
  clearAuthToken: {
    root: true,
    handler({ commit }) {
      commit('clearAuthToken');
    },
  },
  clearAuthTokenId: {
    root: true,
    handler({ commit }) {
      commit('clearAuthTokenId');
    },
  },
  setUserInfo: {
    root: true,
    handler({ commit }, userData) {
      const { userRole = '', fiduciaries = [] } = userData || { userRole: '', fiduciaries: [] };
      commit('setUserInfo', { userRole, fiduciaries });
    },
  },
  clearUserInfo: {
    root: true,
    handler({ commit }) {
      commit('clearAuthToken');
      commit('clearUserInfo');
      commit('clearFiduciary');
      window && window.localStorage && window.localStorage.removeItem('vuex');
    },
  },
  setFiduciary: {
    root: true,
    handler({ commit, state }, fiduciary) {
      commit('updateFiduciary', fiduciary);
    },
  },
  clearFiduciary: {
    root: true,
    handler({ commit }) {
      commit('clearFiduciary');
    },
  },
};

const mutations = {
  setAuthToken(state, authTokenData) {
    const { tokenId = '' } = authTokenData || {};
    state.auth.tokenId = true;
    setCookie('ms-sso', tokenId);
  },
  setAuthTokenId(state) {
    state.auth.tokenId = true;
  },
  clearAuthToken(state) {
    state.auth.tokenId = false;
    setCookie('ms-sso', '');
  },
  clearAuthTokenId(state) {
    state.auth.tokenId = false;
  },
  setUserInfo(state, userData) {
    const { userRole, fiduciaries } = userData || {};
    state.userRole = userRole;
    state.fiduciaries = fiduciaries;
    state.policies = policies;
    state.policies = merge({}, state.policies, policiesByRole[userRole]);
  },
  clearUserInfo(state) {
    state.userRole = '';
    state.fiduciaries = '';
  },
  updateFiduciary(state, fiduciaryData) {
    const { id, fiduciaryCode, fiduciaryName } = fiduciaryData || {};
    state.fiduciary.id = id;
    state.fiduciary.code = fiduciaryCode;
    state.fiduciary.name = fiduciaryName;
  },
  clearFiduciary(state) {
    state.fiduciary.id = 0;
    state.fiduciary.code = '';
    state.fiduciary.name = '';
  },
};

const getters = {
  hasUserInfo(state) {
    return !!state.auth.tokenId;
  },
  hasFiduciaryInfo(state) {
    return !!(state.fiduciary && state.fiduciary.id);
  },
  hasAccessToBrowseIn(state, getters) {
    return getters.hasUserInfo && getters.hasFiduciaryInfo;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};
